import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import styles from './css/MainBanner.module.css';

import { Autoplay, Pagination, Navigation } from 'swiper';
import { optimizeCloudinaryUrl } from './js/util';

const slides = [
  {
    desktop: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705893944/wmzeuycnkxyldfnqllyz.webp',
    mobile: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705894339/s3apdxiz3mrpz10rnagw.webp',
  },
  {
    desktop: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705894160/pctlvk82ff1jglnxbr8u.webp',
    mobile: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705894383/hmawll6d2csndmpwcapj.webp',
  },
  {
    desktop: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705894235/hjuxcgvbiummki1uufp5.webp',
    mobile: 'https://res.cloudinary.com/daqjqq0hy/image/upload/v1705894418/fkfz6kwisiv2lcvzajgf.webp',
  },
];

export default function MainBanner() {
  return (
    <section className={`mainBanner ${styles.heroSection}`}>
      <Swiper
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        grabCursor={true}
        slidesPerView={1}
        loop={true}
        pagination={{
          type: 'fraction',
          clickable: true,
        }}
        navigation={true}
        speed={1000}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper mainSlider"
      >
        {slides.map((slide, idx) => {
          return (
            <SwiperSlide key={idx} className={styles.slideWrapBox}>
              <div className={styles.slideInner}>
                <picture className={styles.slidePicture}>
                  <source media="(max-width: 1200px)" srcSet={optimizeCloudinaryUrl(slide.mobile, 800)} />
                  <img
                    className={styles.bannerImg}
                    src={optimizeCloudinaryUrl(slide.desktop, 1920)}
                    alt={`Main Banner ${idx + 1}`}
                    width={1920}
                    height={600}
                    fetchpriority={idx === 0 ? 'high' : 'auto'}
                    loading={idx === 0 ? 'eager' : 'lazy'}
                    decoding="sync"
                  />
                </picture>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* 에디토리얼 오버레이 (슬라이드 위 고정) */}
      <div className={styles.heroOverlay}>
        <p className={styles.heroEyebrow}>2026 SUMMER COLLECTION</p>
        <h2 className={styles.heroTitle}>
          QUIET
          <br />
          ESSENTIALS
        </h2>
        <p className={styles.heroSub}>절제된 무드, 완성도 높은 데일리 워드로브</p>
        <Link to="/shop" className={styles.heroBtn}>
          SHOP NOW
        </Link>
      </div>
    </section>
  );
}
